/* ==========================================================================
   MD3 RIPPLE — Material Design 3 pressed-state ripple
   One delegated listener; fully progressive (everything works without it).
   Respects prefers-reduced-motion. Styles live in md3-components.css
   (.md3-ripple + @keyframes md3-ripple).
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = [
    '.btn',
    '.sk-btn',
    '.quick-add__submit',
    '.icon-btn',
    '.header__icon',
    '.sk-chip',
    '.quantity__button',
    '.pagination__button',
  ].join(', ');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (reducedMotion.matches) return;
      if (event.button && event.button !== 0) return;

      var target = event.target.closest && event.target.closest(SELECTOR);
      if (!target) return;
      if (target.disabled || target.getAttribute('aria-disabled') === 'true') return;

      var rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      // The ripple needs a positioned, clipped container; buttons styled by
      // the MD3 layer already have position:relative + overflow:hidden, but
      // guard for the rest.
      var computed = window.getComputedStyle(target);
      if (computed.position === 'static') target.style.position = 'relative';
      if (computed.overflow !== 'hidden') target.style.overflow = 'hidden';

      var size = Math.max(rect.width, rect.height) * 2.2;
      var ripple = document.createElement('span');
      ripple.className = 'md3-ripple';
      ripple.style.width = size + 'px';
      ripple.style.height = size + 'px';
      ripple.style.left = event.clientX - rect.left - size / 2 + 'px';
      ripple.style.top = event.clientY - rect.top - size / 2 + 'px';

      ripple.addEventListener('animationend', function () {
        ripple.remove();
      });

      target.appendChild(ripple);
    },
    { passive: true }
  );
})();
